import script from "./RegisterForm.vue?vue&type=script&setup=true&name=join_RegisterForm&lang=js"
export * from "./RegisterForm.vue?vue&type=script&setup=true&name=join_RegisterForm&lang=js"

const __exports__ = script;

export default __exports__